import * as liff from '@line/liff';
import { useEffect, useState } from 'react';

import Context from './Context';

const initLiff = async (liffConfig) => {
    try {
        await liff.init(liffConfig);
        return { liff, ready: true };
    } catch (error) {
        return { liff, error, ready: false };
    }
};

const Provider = ({ children, liffId, mock }) => {
    const [error, setError] = useState('');
    const [liff, setLiff] = useState(undefined);
    const [ready, setReady] = useState(false);
    const [isLoggedIn, setIsLoggedIn] = useState(false);

    useEffect(() => {
        console.log(mock);
        if (mock) {
            setError(mock.error);
            setLiff(mock);
            setReady(mock.ready);
            setIsLoggedIn(mock.isLoggedIn());
            return;
        }

        (async () => {
            const { error, liff, ready } = await initLiff({ liffId });
            setError(error);
            setLiff(liff);
            setReady(ready);
            if (!error && ready) setIsLoggedIn(liff.isLoggedIn());
        })();
    }, [liffId, mock]);

    const props = {
        error,
        liff,
        isLoggedIn,
        ready
    };

    return <Context.Provider value={{ ...props }}>{children}</Context.Provider>;
};

export default Provider;
